import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["preview", "full"];

  connect() {
    this.previewTarget.style.display = "block";
    this.fullTarget.style.display = "none";
  }

  showMore() {
    this.previewTarget.style.display = "none";
    this.fullTarget.style.display = "block";
  }

  showLess() {
    this.previewTarget.style.display = "block";
    this.fullTarget.style.display = "none";
  }
}
